import { pxToEm } from 'util/pxToEm';
import React, { ReactElement } from 'react';
import { Box, Typography } from '@mui/material';

export interface ModalCloseButtonProps {
  onClose: () => void;
}

export const ModalCloseButton = ({ onClose }: ModalCloseButtonProps): ReactElement => (
  <Box sx={{ display: 'flex', justifyContent: 'center', pt: 24, pb: 8, backgroundColor: '#ffffff', position: 'sticky', bottom: 0 }}>
    <Typography
      onClick={onClose}
      sx={{ fontSize: pxToEm(16), fontWeight: 400, color: '#23305F', cursor: 'pointer', textAlign: 'center', '&:hover': { opacity: 0.7 } }}
    >
      Close
    </Typography>
  </Box>
);
